<template>
    <div class="demographics-chart">
        <div class="chart-container">
            <div class="chart-header">
                <h5>
                    <i class="fal fa-map-marked-alt text-primary"></i>
                    Distribución Regional
                </h5>
            </div>

            <div v-if="sortedRegions.length === 0" class="empty-state">
                Sin datos disponibles
            </div>

            <div v-else class="bars-list">
                <div
                    v-for="(region, index) in sortedRegions"
                    :key="region.region"
                    class="bar-row"
                >
                    <div class="bar-label" :title="region.region">
                        {{ region.region }}
                    </div>
                    <div class="bar-track">
                        <div
                            class="bar-fill"
                            :style="{
                                width: pct(region.cantidad, maxValue) + '%',
                                background: colorFor(index),
                            }"
                        ></div>
                    </div>
                    <div class="bar-total">{{ region.cantidad }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DemographicsChart",
    props: {
        demographicsData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            colors: [
                "#3b82f6", // azul
                "#10b981", // verde
                "#f59e0b", // amarillo/naranja
                "#8b5cf6", // morado
                "#ef4444", // rojo
                "#06b6d4", // cyan
                "#ec4899", // rosa
                "#14b8a6", // teal
                "#f97316", // naranja
                "#6366f1", // indigo
                "#84cc16", // lima
                "#a855f7", // violeta
            ],
        };
    },
    computed: {
        sortedRegions() {
            return [...this.demographicsData]
                .map((r) => ({
                    region: r.region || "Sin región",
                    cantidad: Number(r.cantidad || 0),
                }))
                .sort((a, b) => b.cantidad - a.cantidad);
        },
        maxValue() {
            const values = this.sortedRegions.map((r) => r.cantidad);
            return Math.max(1, ...values);
        },
    },
    methods: {
        pct(value, max) {
            if (!max) return 0;
            return (value / max) * 100;
        },
        colorFor(index) {
            return this.colors[index % this.colors.length];
        },
    },
};
</script>

<style scoped>
.demographics-chart {
    margin-bottom: 20px;
}

.chart-container {
    background: #ffffff;
    border-radius: 14px;
    padding: 22px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 20px;
}

.chart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
}

.chart-header h5 {
    color: #1f2937;
    font-weight: 600;
    margin: 0;
}

.bars-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.bar-row {
    display: grid;
    grid-template-columns: 180px 1fr 36px;
    align-items: center;
    gap: 14px;
}

.bar-label {
    font-size: 0.88rem;
    color: #374151;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.bar-track {
    height: 14px;
    background: #f3f4f6;
    border-radius: 999px;
    overflow: hidden;
}

.bar-fill {
    height: 100%;
    border-radius: 999px;
    transition: width 0.4s ease;
}

.bar-total {
    text-align: right;
    font-weight: 700;
    color: #111827;
    font-size: 0.92rem;
}

.empty-state {
    text-align: center;
    color: #9ca3af;
    padding: 40px 0;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .chart-container {
        padding: 18px;
    }
    .bar-row {
        grid-template-columns: 120px 1fr 30px;
        gap: 10px;
    }
    .bar-label {
        font-size: 0.78rem;
    }
}
</style>
